import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveUserPerosnalInfoinAllApplications } from '../../../AdminActionCreator.component';
import moment from 'moment';

const salutationData = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Mrs', label: 'Mrs' },
]
const genderData = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Others', label: 'Others' },
]
const LanguageData = [
    { value: 'English', label: 'English' },
    { value: 'Hindi', label: 'Hindi' },
]

const textFieldData = [
    { label: "Salutation", value: "salutation", placeholder: "Select Salutation", type: "text", name: "salutation" },
    { label: "First Name", value: "firstName", placeholder: "Enter First Name", type: "text", name: "firstName" },
    { label: "Middle Name", value: "middleName", placeholder: "Enter Middle Name", type: "text", name: "middleName" },
    { label: "Last Name", value: "lastName", placeholder: "Enter Last Name", type: "text", name: "lastName" },
    { label: "EmailId", value: "emailId", placeholder: "Enter Email Id", type: "email", name: "emailId" },
    { label: "Gender", value: "gender", placeholder: "Select Gender", type: "text", name: "gender" },
    { label: "D.O.B", value: "dateOfBirth", placeholder: "Enter Date of Birth", type: "date", name: "dateOfBirth" },
    { label: "Mobile Number", value: "mobileNumber", placeholder: "Enter Mobile Number", type: "number", name: "mobileNumber" },
    { label: "Preferred Language", value: "preferredLanguage", placeholder: "Select Preferred Language", type: "text", name: "preferredLanguage" },
]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup }) {
    const [objectData, setObjectData] = useState({
        "salutation": "",
        "firstName": "",
        "middleName": "",
        "lastName": "",
        "emailId": "",
        "gender": "",
        "dateOfBirth": moment(new Date()).format('YYYY-MM-DD'),
        "mobileNumber": "",
        "preferredLanguage": "",
    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                "salutation": data?.salutation || "",
                "firstName": data?.firstName || "",
                "middleName": data?.middleName || "",
                "lastName": data?.lastName || "",
                "emailId": data?.emailId || "",
                "gender": data?.gender || "",
                "dateOfBirth": moment(data?.dob).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD'),
                "mobileNumber": data?.number || "",
                "preferredLanguage": data?.preferredLanguage || "",
            })
        } else {
            setObjectData({
                "salutation": "",
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "emailId": "",
                "gender": "",
                "dateOfBirth": moment(new Date()).format('YYYY-MM-DD'),
                "mobileNumber": "",
                "preferredLanguage": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId, dateOfBirth:moment(objectData?.dateOfBirth).format("DD-MM-YYYY") }
        handleLoader(true)
        SaveUserPerosnalInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Personal Information Updated Successfully")
            }else{
                handleTextPopup(true, "Error Updating Personal Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Personal Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "salutation" && value?.name !== "gender" && value?.name !== "preferredLanguage" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "salutation" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {salutationData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    :
                                                    value?.name == "gender" ?
                                                        <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                            {genderData?.map((option) => (
                                                                <MenuItem key={option.value} value={option.label}>
                                                                    {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        :
                                                        value?.name == "preferredLanguage" ?
                                                            <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                                {LanguageData?.map((option) => (
                                                                    <MenuItem key={option.value} value={option.label}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </TextField>
                                                            :
                                                            ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
